import { axios } from '@/services/axios';

const getServiceCategory = (serviceCategoryId) => {
    return axios.get(`/servicecategory/${serviceCategoryId}`);
};

export default getServiceCategory;
